/**
 * Plugin frontend only scripts
 *
 * @package
 */
console.log( 'bu-testimonials js/scripts.js has loaded and really wants to go back to bed.' );
